import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

type LookerDashboardHash = {
  description: string;
  folder_id: string;
  id: string;
  title: string;
  updated_at?: string;
  view_count?: number;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class LookerDashboardSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    folder: 'folder_id',
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'dashboard') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('looker-dashboard');
    }
    if (key === 'dashboards') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('looker-dashboards');
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(typeClass: ModelSchema, hash: LookerDashboardHash) {
    /**
     * TLDR; race-issue
     * When fetching folders dashboards will be included in the response,
     * but the Looker API doesn't return the updated_at field for dashboards in that case.
     * When fetching dashboards directly, the updated_at field is included.
     * So the issue with this is if the dashboards are fetched first, the updated_at field will set,
     * but after the folders request resolves, the updated_at field will be removed from the store,
     * because ember-data will refresh the model with the most-up-to-date data.
     * This is a workaround to prevent the updated_at field from being removed,
     * meaning if the updated_at field is null, we remove it from the hash so ED won't touch that field.
     * Same goes for: view_count
     */
    if (!hash.updated_at) {
      delete hash.updated_at;
    }

    if (!hash.view_count) {
      delete hash.view_count;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, hash);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  payloadKeyFromModelName() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.payloadKeyFromModelName('dashboard');
  }
}
